/* Block - Faq.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 */
/* eslint-disable-next-line */
import styles from "./block-faq.scss";
import Accordion from '../../js/component/_accordion.js';
Accordion.toggle();
